import View from "views/logic/views/View";
import AggregationWidget from "views/logic/aggregationbuilder/AggregationWidget";
import AggregationWidgetConfig from "views/logic/aggregationbuilder/AggregationWidgetConfig";
import DataTable from "views/components/datatable";
import { DEFAULT_TIMERANGE } from "views/Constants";
import { addWidget } from "views/logic/slices/widgetActions";
import { selectView } from "views/logic/slices/viewSelectors";
export const CreateCustomAggregation = ({ view }) => AggregationWidget.builder().newId().timerange(view.type === View.Type.Dashboard ? DEFAULT_TIMERANGE : void 0).config(AggregationWidgetConfig.builder().rowPivots([]).series([]).visualization(DataTable.type).build()).build();
export default () => (dispatch, getState) => {
  const view = selectView(getState());
  return dispatch(addWidget(CreateCustomAggregation({ view })));
};
